<div class="relative w-full">
    <!-- Visible text input (readonly) -->
    <input
        type="text"
        readonly
        [value]="displayValue"
        (click)="openPicker()"
        (blur)="onTouched()"
        [disabled]="disabled"
        [class]="'input input--primary w-full pr-10 ' + (inputClass || '')"
        [placeholder]="effectivePlaceholder"
        class="cursor-pointer"
    />

    <!-- Hidden native date/datetime picker -->
    <input
        #hiddenInput
        [type]="type"
        [value]="internalValue"
        (change)="onInputChange($event)"
        [disabled]="disabled"
        class="hidden-picker"
        tabindex="-1"
    />

    <!-- Calendar icon -->
    <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
        <lucide-icon [img]="Calendar" [class]="iconClass"></lucide-icon>
    </div>
</div>
